import DVRSnapshotsService from './service/DVRSnapshotsService';

import {
  DVR_SNAPSHOTS_REQUEST,
  DVR_SNAPSHOTS_SUCCESS,
  DVR_SNAPSHOTS_OFFLINE,
  DVR_SNAPSHOTS_FAILURE,
  DVR_SNAPSHOTS_NOT_AVAILABLE,
  DVR_SNAPSHOTS_CAROUSEL_OPENED,
  DVR_SNAPSHOTS_CAROUSEL_CLOSED
} from './DVRSnapshotsActionsType';

export const getCachedSnapshots = dvr => async dispatcher => {
  try {
    const snapshots = await DVRSnapshotsService.getSnapshots(dvr, {cached: true});

    if (snapshots) {
      dispatcher({type: DVR_SNAPSHOTS_SUCCESS, payload: snapshots});
    } else {
      dispatcher({type: DVR_SNAPSHOTS_NOT_AVAILABLE});
    }
  } catch (err) {
    console.error('Unable to get snapshots', err);

    dispatcher({type: DVR_SNAPSHOTS_FAILURE, payload: err});
  }
};

export const getSnapshots = dvr => async dispatcher => {
  dispatcher({type: DVR_SNAPSHOTS_REQUEST});

  try {
    const snapshots = await DVRSnapshotsService.getSnapshots(dvr);

    if (snapshots) {
      dispatcher({type: DVR_SNAPSHOTS_SUCCESS, payload: snapshots});
    } else {
      dispatcher({type: DVR_SNAPSHOTS_OFFLINE});
    }
  } catch (err) {
    console.error('Unable to get snapshots', err);

    dispatcher({type: DVR_SNAPSHOTS_FAILURE, payload: err});
  }
};

export const openSnapshotsCarousel = activeChannelName => async dispatcher => {
  dispatcher({type: DVR_SNAPSHOTS_CAROUSEL_OPENED, payload: {activeChannelName}});
};

export const closeSnapshotsCarousel = () => async dispatcher => {
  dispatcher({type: DVR_SNAPSHOTS_CAROUSEL_CLOSED});
};
